export default "__VITE_ASSET__BNvFTpZc__"